import React from "react";
import { SRLWrapper } from "simple-react-lightbox"; // Import SRLWrapper
import mannaT from "../../assets/img/gallery/thumbnail/manna-web.jpg"
import manna from "../../assets/img/gallery/manna-web.jpg"
import kuhneT from "../../assets/img/gallery/thumbnail/kuhne-web.jpg"
import kuhne from "../../assets/img/gallery/kuhne-web.jpg"
import kuruyemisT from "../../assets/img/gallery/thumbnail/kuruyemisborsasi-web.jpg"
import kuruyemis from "../../assets/img/gallery/kuruyemisborsasi-web.jpg"
import livaT from "../../assets/img/gallery/thumbnail/liva-web.jpg"
import liva from "../../assets/img/gallery/liva-web.jpg"
import lodaT from "../../assets/img/gallery/thumbnail/loda-web.jpg"
import loda from "../../assets/img/gallery/loda-web.jpg"
import arcadiumT from "../../assets/img/gallery/thumbnail/arcadium-web.jpg"
import arcadium from "../../assets/img/gallery/arcadium-web.jpg"
import cetmenT from "../../assets/img/gallery/thumbnail/cetmen-web.jpg"
import cetmen from "../../assets/img/gallery/cetmen-web.jpg"
import enzaT from "../../assets/img/gallery/thumbnail/enza-web.jpg"
import enza from "../../assets/img/gallery/enza-web.jpg"
import ergulT from "../../assets/img/gallery/thumbnail/ergul-web.jpg"
import ergul from "../../assets/img/gallery/ergul-web.jpg"
import hacibabaT from "../../assets/img/gallery/thumbnail/hacibaba-web.jpg"
import hacibaba from "../../assets/img/gallery/hacibaba-web.jpg"
import homT from "../../assets/img/gallery/thumbnail/hom-web.jpg"
import hom from "../../assets/img/gallery/hom-web.jpg"
import ideaportT from "../../assets/img/gallery/thumbnail/ideaport-web.jpg"
import ideaport from "../../assets/img/gallery/ideaport-web.jpg"
import kentparkT from "../../assets/img/gallery/thumbnail/kentpark-web.jpg"
import kentpark from "../../assets/img/gallery/kentpark-web.jpg"
import konforT from "../../assets/img/gallery/thumbnail/konfor-web.jpg"
import konfor from "../../assets/img/gallery/konfor-web.jpg"

import pakmaya from "../../assets/img/gallery/pakmaya-web.jpg"
import pakmayaPpd from "../../assets/img/gallery/pakmaya-ppd-web.jpg"
import pakmayaMy from "../../assets/img/gallery/pakmaya-my-web.jpg"
import oracle from "../../assets/img/gallery/oracle-web.jpg"
import mehmetcik from "../../assets/img/gallery/mehmetcik-web.jpg"
import matbuu from "../../assets/img/gallery/matbuu-web.jpg"
import linkplus from "../../assets/img/gallery/linkplus-web.jpg"
import ideanest from "../../assets/img/gallery/ideanest-web.jpg"
import pakmayaT from "../../assets/img/gallery/thumbnail/pakmaya-web.jpg"
import pakmayaPpdT from "../../assets/img/gallery/thumbnail/pakmaya-ppd-web.jpg"
import pakmayaMyT from "../../assets/img/gallery/thumbnail/pakmaya-my-web.jpg"
import oracleT from "../../assets/img/gallery/thumbnail/oracle-web.jpg"
import mehmetcikT from "../../assets/img/gallery/thumbnail/mehmetcik-web.jpg"
import matbuuT from "../../assets/img/gallery/thumbnail/matbuu-web.jpg"
import linkplusT from "../../assets/img/gallery/thumbnail/linkplus-web.jpg"
import ideanestT from "../../assets/img/gallery/thumbnail/ideanest-web.jpg"

const List = () => {
  const imgs = [
    {
      thumb: pakmayaT,
      img: pakmaya,
      head: 'Pakmaya',
      alt: 'Pakmaya Website Design & Development',
    },
    {
      thumb: pakmayaPpdT,
      img: pakmayaPpd,
      head: 'Pakmaya Profesyoneller Dünyası',
      alt: 'Pakmaya Profesyoneller Dünyası Website Design & Development',
    },
    {
      thumb: pakmayaMyT,
      img: pakmayaMy,
      head: 'Pakmaya Mutfağın Yıldızı',
      alt: 'Pakmaya Mutfağın Yıldızı Website Design & Development',
    },
    {
      thumb: oracleT,
      img: oracle,
      head: 'Oracle',
      alt: 'Oracle Website Design & Development',
    },
    {
      thumb: mehmetcikT,
      img: mehmetcik,
      head: 'Mehmetçik Vakfı',
      alt: 'Mehmetçik Vakfı Website Design & Development',
    },
    {
      thumb: matbuuT,
      img: matbuu,
      head: 'Matbuu',
      alt: 'Matbuu Website Design & Development',
    },
    {
      thumb: linkplusT,
      img: linkplus,
      head: 'Linkplus',
      alt: 'Linkplus Website Design & Development',
    },
    {
      thumb: ideanestT,
      img: ideanest,
      head: 'Ideanest',
      alt: 'Ideanest Website Design & Development',
    },
    {
      thumb: mannaT,
      img: manna,
      head: 'Manna Hotel',
      alt: 'Manna Hotel Website Design & Development',
    },
    {
      thumb: kuhneT,
      img: kuhne,
      head: 'Kuhne',
      alt: 'Kuhne Website Design & Development',
    },
    {
      thumb: kuruyemisT,
      img: kuruyemis,
      head: 'Kuruyemiş Borsası',
      alt: 'Kuruyemiş Borsası Website Design & Development',
    },
    {
      thumb: livaT,
      img: liva,
      head: 'Liva Pastacılık',
      alt: 'Liva Pastacılık Website Design & Development',
    },
    {
      thumb: lodaT,
      img: loda,
      head: 'Loda',
      alt: 'Loda Website Design & Development',
    },
    {
      thumb: arcadiumT,
      img: arcadium,
      head: 'Arcadium AVM',
      alt: 'Arcadium AVM Website Design & Development',
    },
    {
      thumb: cetmenT,
      img: cetmen,
      head: 'Çetmen',
      alt: 'Çetmen Website Design & Development',
    },
    {
      thumb: enzaT,
      img: enza,
      head: 'Enza',
      alt: 'Enza Website Design & Development',
    },
    {
      thumb: ergulT,
      img: ergul,
      head: 'Ergül Keskin',
      alt: 'Ergül Keskin Website Design & Development',
    },
    {
      thumb: hacibabaT,
      img: hacibaba,
      head: 'Kahveci Hacıbaba',
      alt: 'Kahveci Hacıbaba Website Design & Development',
    },

    {
      thumb: homT,
      img: hom,
      head: 'Hom',
      alt: 'Hom Website Design & Development',
    },
    {
      thumb: ideaportT,
      img: ideaport,
      head: 'İdeaport',
      alt: 'İdeaport Website Design & Development',
    },
    {
      thumb: kentparkT,
      img: kentpark,
      head: 'Kentpark AVM',
      alt: 'Kentpark AVM Website Design & Development',
    },
    {
      thumb: konforT,
      img: konfor,
      head: 'Konfor',
      alt: 'Konfor Website Design & Development',
    },

  ]

  return (
    imgs.map((item, i) => {
      return (
        <div key={i} className="image">
          <div className="hover">
            <a href={item.img} className="thumb" data-attribute="SRL">
              <img alt={item.alt} src={item.thumb} />
            </a>
          </div>
          <p className="img-head">{item.head}</p>
          <p>{item.alt}</p>
        </div>
      )
    })
  );
}



function WebDevGallery() {
  return (
    <SRLWrapper>
      <div className="gallery container">
       <List />
      </div>
    </SRLWrapper>
  );
}

export default WebDevGallery;